import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useAppSelector } from '../../../../../../redux/hooks';

// Components 

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { getPatient } from '../../../../../../routes/doctor/patients';


type Props = {
    _id: string, 
};

const PatientRow: React.FC<Props> = ({ _id }) => {

    const colors = useAppSelector(state => state.theme.colors);
    const patient = useAppSelector(state => state.patient.patient) as any; 

    const [patientName, setPatientName] = useState(''); 

    // -- 

    const handlePatientName = async () => { 

        const res = await getPatient(_id) as any; 

        if (res.data.status === 200) { 

            setPatientName(`${res.data.patient.firstName} ${res.data.patient.lastName}`); 

        }; 

    }; 

    // -- 

    useEffect(() => { 

        if (_id) { 

            handlePatientName(); 

        }; 

    },[_id]); 

    return (

        <Box 
            sx={{
            display: 'flex', 
            flexDirection: 'row',
            alignItems: 'center', 
            width: '100%',
            height: 40,
            color: colors?.text,
            backgroundColor: patient?._id === _id ? colors?.selectedSectionHover : 'transparent',
            '&:hover': { backgroundColor: patient?._id === _id ? colors?.selectedSectionHover : colors?.patientRowUnselected }
        }}>

            <Box 
                component="img" 
                sx={{ 
                    width: 20, 
                    marginLeft: 2 
                    }} 
                src={require('../../../../../../assets/icons/consultation/select-patient-avatar.png')} 
            />

            <Box sx={{ fontSize: 14, marginLeft: 2 }}>{patientName}</Box>

        </Box>
  );
};

export default PatientRow;